import React from 'react'
import { Button } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import './SaveCarButton.css'

export default class SaveCarButton extends React.Component {
  state = {
    saved: !!this.props.on,
  }

  handleSavedCarToggle = event => {
    event.preventDefault()
    this.setState(state => ({ saved: !state.saved }))
    this.props.onClick(this.props.vin)
  }

  render() {
    return (
      <Button onClick={this.handleSavedCarToggle} className="SaveCarButton">
        <FontAwesome name={this.state.saved ? 'heart' : 'heart-o'} />
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DataView/SaveCarButton.js